module.exports = __webpack_public_path__ + "static/media/galdinsLose_75_100.a8ffa58a.png";